module.exports = __webpack_public_path__ + "resources/img/img_codesign2.599c2645ab50d440dc4bbf57371b2777.png";